import { component } from './component';
import { breadcrumb } from './breadcrumb';
import { unit } from './unit';
import { validation_errors } from './validation_errors';

export const shared = {
  component,
  breadcrumb,
  unit,
  validation_errors,

  template: {
    footer: {
      email: 'Alamat e-mail'
    }
  },

  date: {
    last_mounth: 'bulan lalu',
    '3_mounths': '3 bulan',
    '6_mounths': '6 bulan',
    year: 'tahun',
    all_period: 'seluruh periode'
  },

  error_page: {
    403: {
      title: 'Access ditolak',
      description: 'Kami sedang memperbaiki hal tersebut'
    },
    404: {
      title: 'Maaf, halaman yang Anda cari tidak dapat ditemukan.',
      description: 'Kami sedang memperbaiki hal tersebut'
    },
    500: {
      title: 'Internal',
      description: 'Kami sedang memperbaiki hal tersebut'
    },
    520: {
      title: 'Error',
      description: 'Kami sedang memperbaiki hal tersebut'
    },

    link: {
      to_index: 'To Main page'
    }
  },
  referrer: {
    old_version:
      'Versi lama akun pribadi tidak lagi didukung. Silakan masuk ke versi baru untuk mendapatkan semua manfaat dari layanan kami.'
  },

  errors: {
    incorrect_login: 'Nama pengguna atau kata sandi salah',
    authorisation: 'Kesalahan Otorisasi',
    input_form: 'Isi formulir',
    'The given data was invalid.': 'Permintaan tidak valid'
  },
  loading: 'Memuat',
  select: 'Pilih'
};
